import * as LucideIcons from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

import { iconMap, type IconName } from './icon-list';

export function getIconMapName(iconName: string): string {
  if (iconMap[iconName as IconName]) {
    return iconMap[iconName as IconName];
  }
  // Already a Lucide name (new selections from IconSelect)
  if (LucideIcons[iconName as keyof typeof LucideIcons]) {
    return iconName;
  }
  return 'Car';
}

export function getIcon(iconName: string): LucideIcon {
  if (!LucideIcons[iconName as keyof typeof LucideIcons]) {
    return LucideIcons.Car as LucideIcon;
  }
  return LucideIcons[iconName as keyof typeof LucideIcons] as LucideIcon;
}

export { iconMap, getIconNames } from './icon-list';
export type { IconName } from './icon-list';
